import base from "/app/images/play.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");